import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {ServicesService} from "../../services/services-service.service";
import {ServicesFacadeService} from "../../angular/services/services-facade.service";
import {take} from "rxjs";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {RouteModel} from "../../../routes/models/route.model";
import {DeliveriesDialogService} from "../../services/deliveries-dialog-service.service";
import {FulfillmentService} from "../../../fulfillment/services/fulfillment-service.service";

export class DeliveriesActionFooterCtrl implements IController {
  ids: string[];
  routeIds?: string[];
  routes: RouteModel[];
  serviceType: any;
  selectedServices: any;
  onActionComplete: Function;
  onClear: Function;

  public enabledActions: any = [];
  public extraActions: any;

  private extraActionNames: any;
  private blockResetAction: boolean;
  public servicesRef: any;
  public printerProvider: string;
  public services: any[];


  /* @ngInject */
  constructor(private servicesService: ServicesService, private DeliveriesApiAction, private deliveriesConstants, private splitService, private $timeout,
              private servicesFacadeService: ServicesFacadeService, private $delivery, private commonsDialogService: CommonsDialogService,
              private deliveriesDialogService: DeliveriesDialogService, private fulfillmentService: FulfillmentService) {
  }

  $onInit() {
    this.printerProvider = this.splitService.getPrinterProvider();
    this.extraActionNames = this.deliveriesConstants.extraActions;
    this.blockResetAction = this.splitService.getServiceBlockResetAction();
    this.servicesRef = this.$delivery();
    this.setActions();
  }

  $onChanges(changes) {
    if ((changes.ids && !changes.ids.isFirstChange()) || (changes.routeIds && !changes.routeIds.isFirstChange())) {
      this.setActions();
    }
  }

  setActions() {
    if (!this.ids?.length && !this.routeIds?.length) {
      this.enabledActions = [];
      this.extraActions = [];
      return;
    }

    this.servicesFacadeService.selectByIds(this.ids).pipe(take(1)).subscribe((services) => {
      if (!!services.length) {
        this.services = services;
        this.initActions(services, this.routes);
      } else {
        this.servicesRef.$asyncValues(this.ids).then((services) => {
          this.services = services;
          this.initActions(services, this.routes);
        })
      }
    });
  }

  private initActions(services, routes) {
    const actions = this.servicesService.getActionsByServices(services, routes);
    this.enabledActions = _.filter(actions, (a) => {
      return !this._isExtraAction(a);
    });
    this.extraActions = _.filter(actions, (a) => {
      return this._isExtraAction(a);
    });
    if (this.blockResetAction) {
      this.extraActions = this.extraActions.filter(a => a.id !== 'reset');
    }

    if (this.printerProvider !== 'Ikea') {
      this.removeIkeaFromExtraActions();
    }
  }

  onActionSelect(action, event) {
    if (action === 'PrintIkea') {
      this.commonsDialogService.printIkea(this.services);
      return;
    }
    if (action === 'Duplicate') {
      this.servicesService.onDuplicateOne(this.services[0]);
    } else if (action === 'Print') {
      if (this.services[0].serviceType === 'Operation') {
        this.servicesService.onPrint([this.services[0].id]);
      } else {
        this.deliveriesDialogService.printDelivery()
          .then((purpose) => {
            this.servicesService.onPrint([this.services[0].id], purpose);
          })
      }
    } else if (action === 'dispatchExternal') {
      this.deliveriesDialogService.dispatchStepExternal(this.services[0].fulfillmentId, this.services[0].fulfillmentStepId, event)
        .then((selectedQuote) => {
          this.fulfillmentService.dispatchStep(this.services[0].fulfillmentId, this.services[0].fulfillmentStepId, selectedQuote);
        })
    } else {
      this.DeliveriesApiAction[action](event, this.ids, this.routeIds)
        .then((deliveryIds) => {
          if (_.isArray(deliveryIds) && deliveryIds.length) {
            const hasStatusChanged = !_.isEqual(action, 'SendToMarket') && !_.isEqual(action, 'Auction') && !_.isEqual(action, 'CreateRoute');
            this.onActionComplete({hasStatusChanged: hasStatusChanged});
          }
        })
    }
  }

  private _isExtraAction(action) {
    return _.includes(this.extraActionNames, action.title);
  }

  private removeIkeaFromExtraActions() {
    this.enabledActions = this.enabledActions.filter(action => {
      return action.id !== "PrintIkea";
    })
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveriesActionFooter', {
    bindings: {
      ids: '<',
      routeIds: '<?',
      routes: '<?',
      serviceType: '<',
      onActionComplete: '&',
      selectedServices: '<',
      onClear: '&'
    },
    template: require('./deliveries-action-footer.html').default,
    controller: DeliveriesActionFooterCtrl
  });
